"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _preact = require("preact");
var _core = require("@uppy/core");
var packageJson = {
    "version": "2.1.2"
};
/**
 * Progress bar
 *
 */ var ProgressBar = /*#__PURE__*/ function(_core_UIPlugin) {
    _inherits(ProgressBar, _core_UIPlugin);
    function ProgressBar(uppy, opts) {
        _class_call_check(this, ProgressBar);
        var _this;
        _this = _call_super(this, ProgressBar, [
            uppy,
            opts
        ]);
        _this.id = _this.opts.id || 'ProgressBar';
        _this.title = 'Progress Bar';
        _this.type = 'progressindicator'; // set default options
        var defaultOptions = {
            target: 'body',
            fixed: false,
            hideAfterFinish: true
        }; // merge default options with the ones set by user
        _this.opts = _object_spread({}, defaultOptions, opts);
        _this.render = _this.render.bind(_this);
        return _this;
    }
    _create_class(ProgressBar, [
        {
            key: "render",
            value: function render(state) {
                var progress = state.totalProgress || 0; // before starting and after finish should be hidden if specified in the options
                var isHidden = (progress === 0 || progress === 100) && this.opts.hideAfterFinish;
                return (0, _preact.h)("div", {
                    className: "uppy uppy-ProgressBar",
                    style: {
                        position: this.opts.fixed ? 'fixed' : 'initial'
                    },
                    "aria-hidden": isHidden
                }, (0, _preact.h)("div", {
                    className: "uppy-ProgressBar-inner",
                    style: {
                        width: "".concat(progress, "%")
                    }
                }), (0, _preact.h)("div", {
                    className: "uppy-ProgressBar-percentage"
                }, progress));
            }
        },
        {
            key: "install",
            value: function install() {
                var target = this.opts.target;
                if (target) {
                    this.mount(target, this);
                }
            }
        },
        {
            key: "uninstall",
            value: function uninstall() {
                this.unmount();
            }
        }
    ]);
    return ProgressBar;
}(_core.UIPlugin);
ProgressBar.VERSION = packageJson.version;
module.exports = ProgressBar;
